import React from 'react'
import { t } from 'ttag'

import { InformationModal } from 'components/modals/common/InformationModal/InformationModal'

export const AbortDeleteInterviewTemplateModal = ({
  onClose,
  onConfirm,
  isOpen,
}) => (
  <InformationModal
    confirmLabel={t`Go back`}
    message={t`Delete for this particular interview template is disabled.`}
    text={t`You cannot delete this Interview template because it is used in a Job position that has Interviews in progress.`}
    title={t`Delete a template`}
    {...{ onClose, onConfirm, isOpen }}
  />
)
